import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { PartnerBrandService } from '@campfire-nx/api';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { OdoReadingService } from '@open-portal-app/policy/odo-reading/services/odo-reading.service';

@Injectable({
  providedIn: 'root',
})
export class OdoResolver implements Resolve<any> {

  constructor(
    private router: Router,
    private odoReadingService: OdoReadingService,
    private partnerBrandService: PartnerBrandService,
    private authService: AuthService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    const uuid = route.params.uuid;

    return this.odoReadingService.getOdoReading(uuid)
      .then((response: any) => {
        // Applying Partner branding
        if (response.partner) {
          this.setPartner(response.partner.slug);
          this.authService.setApiKey(response.partner.api_key);
        };

        return response;
      })
      .catch((error: any) => {
        if (error.error?.partner) {
          this.setPartner(error.error.partner.slug);
          this.authService.setApiKey(error.error.partner.api_key);
        };

        if (error.status === 400 || error.status === 403 || error.status >= 500) {
          this.router.navigate(['/bad-request']);
        } else if (error.status === 404) {
          this.router.navigate(['/not-found']);
        };

        return error;
      });
  };

  setPartner(partnerSlug: string) {
    this.partnerBrandService.setPartner(partnerSlug);
  };
}
